import React, { useLayoutEffect, useRef } from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import Footer from "./components/common/footer";
import Navbar from "./components/common/header";
import routes from "./routes/router.config";
import { UserProvider, useUser } from "../src/components/context/UserContext";
import { BuyWishlistProvider } from "../src/components/context/BuyContext";
import {
  LoginModalProvider,
  useLoginModal,
} from "../src/components/context/LoginPopUpContext";
import LoginPopUp from "./components/common/LoginPopUp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import Cookies from "js-cookie";
import { applyAuthTokensFromUrl } from "./utils/authTokens";
import OfferStrip from "./components/home/offer-sleek"

// Admin login-as-owner lands with tokens in the URL — store cookies immediately
applyAuthTokensFromUrl();

function LoginPopUPWrapper() {
  const { showLogin, closeLogin, afterlogin, resetVisitCount } =
    useLoginModal();
  return (
    <>
      <LoginPopUp
        show={showLogin}
        close={closeLogin}
        action={afterlogin}
        resetVisitCount={resetVisitCount}
      />
    </>
  );
}

/** Syncs UserContext when admin opens owner pages with tokens in the hash. */
function AuthFromUrlSync() {
  const { setAuthentication } = useUser();
  const location = useLocation();
  const didInitialSync = useRef(false);

  useLayoutEffect(() => {
    const applied = applyAuthTokensFromUrl();
    if (
      applied ||
      (!didInitialSync.current && Cookies.get("accessToken"))
    ) {
      setAuthentication(true);
    }
    didInitialSync.current = true;
  }, [location.pathname, location.hash, location.search, setAuthentication]);

  return null;
}

function App() {
  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useLayoutEffect(() => {
      document.documentElement.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }, [pathname]);

    return null;
  };

  return (
    <main>
      {/* <TawkMessengerReact
        propertyId="66925cd432dca6db2caecf73"
        widgetId="1i2lrl7jf"
      /> */}
      <UserProvider>
        <BuyWishlistProvider>
          <LoginModalProvider>
            <HelmetProvider>
                <Helmet>
    <title>Flats and Apartments for Rent in Bangalore | Semi furnished & Fully Furnished | Werentt</title>
    <meta
      name="description"
      content="Planning to rent a house in Bangalore? Rent 1BHK, 2BHK- semi furnished or full furnished flats or apartments from Werentt today! Contact to know more."
    />
  </Helmet>



              <Router>
                <ToastContainer autoClose={2000} />
                <AuthFromUrlSync />
                <LoginPopUPWrapper />
                <ScrollToTop />
                <Navbar />
                    <OfferStrip/>
                <Routes>
                  {routes.map((route, index) => (
                    <Route
                      key={index}
                      path={route.path}
                      element={route.element}
                    >
                      {route.children?.map((child, idx) => (
                        <Route
                          key={idx}
                          path={child.path}
                          element={child.element}
                        />
                      ))}
                    </Route>
                  ))}
                </Routes>
                <Footer />
              </Router>
            </HelmetProvider>
          </LoginModalProvider>
        </BuyWishlistProvider>
      </UserProvider>
    </main>
  );
}

export default App;
